<template>
<div>
        <v-card>
            <v-card-title>
                <v-icon color="primary"> mdi-information </v-icon>
                <span class="pl-2">{{ $t('users.schoolCard.title') }}</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.students') }}</p>
                        <div class="mt-4">
                            <p>{{ school.student_count }}</p>
                        </div>
                    </v-col>
                    <!-- drivers -->
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.drivers') }}</p>
                        <div class="mt-4">
                            <p>{{ school.driver_count }}</p>
                        </div>
                    </v-col>
                    <!-- buses -->
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.buses') }}</p>
                        <div class="mt-4">
                            <p>{{ school.bus_count }}</p>
                        </div>
                    </v-col>

                    <!-- stops -->
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.stops') }}</p>
                        <div class="mt-4">
                            <p>{{ school.stop_count }}</p>
                        </div>
                    </v-col>

                    <!-- routes -->
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.routes') }}</p>
                        <div class="mt-4">
                            <p>{{ school.route_count }}</p>
                        </div>
                    </v-col>

                    <!-- trips -->
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.schoolCard.trips') }}</p>
                        <div class="mt-4">
                            <p>{{ school.trip_count }}</p>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="my-4">
            <v-card-title>
                <v-icon color="primary"> mdi-information </v-icon>
                <span class="pl-2">{{ $t('users.schoolCard.taxInfoTitle') }}</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.invoiceDataTitle') }}</p>
                        <div class="mt-4">
                            <p>{{ school.invoice_data_title }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyName') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_name }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyJob') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_job }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyAddress') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_address }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyAddressPoBox') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_address_po_box }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyCity') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_city }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyCountry') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_country }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyVat') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_vat }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.companyGemiNumber') }}</p>
                        <div class="mt-4">
                            <p>{{ school.company_gemi_number }}</p>
                        </div>
                    </v-col>

                    <v-col cols="12" md="4">
                        <p class="font-weight-bold">{{ $t('users.fields.taxOffice') }}</p>
                        <div class="mt-4">
                            <p>{{ school.tax_office }}</p>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
</div>
</template>

<script>
import AvatarImageComponent from "../../components/AvatarImageComponent.vue";

export default {
    name: "schoolCard",
    props: {
        school: {
            type: Object,
            required: true,
        },
    },
    components: {
        AvatarImageComponent,
    },
};
</script>
